import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind-Klassen sicher zusammenführen (Konflikte gewinnt die letzte). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
